import * as React from 'react';

import {useInflight} from 'src/hooks/redux';

import {useSelector, useDispatch} from 'react-redux';
import type {SenseAiState, Tag} from 'src/reducers/sense-ai';
import {selectSenseAiData} from 'src/selectors/sense-ai';
import {
  setShowAiPanel,
  setShowCustomComponent,
  setPrompt,
  setGeneratedText,
  addTag,
  removeTag,
  receiveAllTags,
  setExternallyAccessibleFields,
  generateContent,
  setError,
  resetSelectedTags,
} from 'src/action-creators/sense-ai';


export const ALL_TAGS = [
  {label: 'Make it friendly', value: 'Make it friendly'},
  {label: 'Make it gender neutral', value: 'Make it gender neutral'},
  {label: 'Make it candid', value: 'Make it candid'},
  {label: 'Make it longer', value: 'Make it longer'},
] as const;

export type SenseAiHookProps = {
  state: SenseAiState;
  isLoading: boolean;
  generateContent: (payload?: Record<any, any>) => Promise<{
    generated_text: string;
  }>;
  addTag: (arg1: string) => unknown;
  removeTag: (arg1: string) => unknown;
  receiveAllTags: (arg1: Tag[]) => unknown;
  resetSelectedTags: () => unknown;
  reset: () => unknown;
  setPrompt: (arg1: string) => unknown;
  setShowAiPanel: (arg1: boolean) => unknown;
  setShowCustomComponent: (arg1: boolean) => unknown;
  setGeneratedText: (arg1: string) => unknown;
  setError: (arg1: string) => unknown;
};

export type Config = {
  deps?: [];
  prompt?: string;
  selectedTags?: string[];
  generatedText?: string;
  error?: string;
  allTags?: Tag[];
};

export const useSenseAi = (
  url: string = '',
  config: Config = {deps: []},
): SenseAiHookProps => {
  const isLoading = useInflight(generateContent(url));

  React.useEffect(() => {
    const {
      prompt = '',
      selectedTags = [],
      generatedText = '',
      error = '',
      allTags = ALL_TAGS,
    } = config;
    const payload = {
      prompt,
      generatedText,
      selectedTags,
      error,
      allTags,
    } as const;
    // @ts-expect-error - TS2345 - Argument of type '{ readonly prompt: string; readonly generatedText: string; readonly selectedTags: string[]; readonly error: string; readonly allTags: Tag[] | readonly [{ readonly label: "Make it friendly"; readonly value: "Make it friendly"; }, { ...; }, { ...; }, { ...; }]; }' is not assignable to parameter of type 'Partial<{ prompt: string; selectedTags: string[]; generatedText: string; error: string; allTags: Tag[]; }>'.
    dispatch(setExternallyAccessibleFields(payload));
  }, config.deps || []);

  const dispatch = useDispatch();
  const state: SenseAiState = useSelector(selectSenseAiData);

  const reset = () => {};

  // @ts-expect-error - TS7006 - Parameter 'fn' implicitly has an 'any' type.
  const dispatcher = (fn) => {
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    return (...args) => dispatch(fn.apply(this, args));
  };

  return {
    state,
    addTag: dispatcher(addTag),
    removeTag: dispatcher(removeTag),
    reset,
    isLoading,
    setPrompt: dispatcher(setPrompt),
    setGeneratedText: dispatcher(setGeneratedText),
    setShowAiPanel: dispatcher(setShowAiPanel),
    setShowCustomComponent: dispatcher(setShowCustomComponent),
    // @ts-expect-error - TS2322 - Type 'ThunkAction<unknown>' is not assignable to type 'Promise<{ generated_text: string; }>'.
    generateContent: (payload) => dispatch(generateContent(url, payload)),
    setError: dispatcher(setError),
    receiveAllTags: dispatcher(receiveAllTags),
    resetSelectedTags: () => dispatch(resetSelectedTags()),
  };
};
